import { useEffect } from 'react';
import { performanceTest } from '@/lib/performanceTest';
import { useLocation } from 'react-router-dom';

/**
 * Hook to automatically test page performance
 * Use this in your pages to track performance metrics
 */
export const usePerformanceTest = (pageName?: string) => {
  const location = useLocation();
  const testName = pageName || location.pathname;

  useEffect(() => {
    // Start test when component mounts
    performanceTest.startPageTest(testName);

    // End test after a delay to capture all metrics
    const timer = setTimeout(() => {
      performanceTest.endPageTest();
    }, 3000); // 3 second delay to capture all resources

    return () => {
      clearTimeout(timer);
    };
  }, [testName]);
};
